const paymentStatus = {
  'Aguardando pagamento': 'default',
  Processando: 'scheduled',
  'Pagamento efetuado': 'success',
  Cancelado: 'inactive',
  'Suspeita de fraude': 'attention',
  Vencido: 'warning',
};

const tagChipPaymentStatus = (status) => paymentStatus[status];

export default tagChipPaymentStatus;
